import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  Checkbox,
  Collapse,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { SystemOneFeedRun } from "../SystemOneFeed";
import { IncludedFeedPlate } from "./IncludedPlate";

interface IncludedFeedRunProps {
  setPlateMapOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedPlate: Dispatch<SetStateAction<any>>;
  run: SystemOneFeedRun;
  runIndex: number;
  plateWorklistInfo: any;
  updateIncludedPlateSelection: (runIndex: number, plateIndex: number) => void;
  updateIncludedRunSelection: (runIndex: number) => void;
  updatePlateWorklistInfo: (
    key: string,
    value: string,
    runIndex: number,
    plateIndex: number
  ) => void;
}

export const IncludedFeedRun = ({
  setPlateMapOpen,
  setSelectedPlate,
  runIndex,
  plateWorklistInfo,
  updateIncludedRunSelection,
  updateIncludedPlateSelection,
  updatePlateWorklistInfo,
}: IncludedFeedRunProps) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            style={{ outline: 0 }}
            aria-label="expand row"
            size="small"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            {collapseOpen ? (
              <KeyboardArrowDownIcon />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
          <Checkbox
            checked={plateWorklistInfo.selected}
            onChange={(e) => updateIncludedRunSelection(runIndex)}
          />
        </TableCell>
        <TableCell>{plateWorklistInfo.runName}</TableCell>
      </TableRow>
      {plateWorklistInfo.plates && collapseOpen ? (
        <div>
          <Collapse in={collapseOpen} unmountOnExit>
            <Table style={{ position: "relative", left: "75px" }}>
              <TableHead>
                <TableCell></TableCell>
                <TableCell style={{ minWidth: "175px" }}>
                  Plate Barcode
                </TableCell>
                <TableCell style={{ minWidth: "50px" }}>Wells</TableCell>
                <TableCell style={{ minWidth: "100px" }}>
                  Aspirate Vol
                </TableCell>
                <TableCell style={{ minWidth: "100px" }}>
                  Dispense Vol
                </TableCell>
                <TableCell style={{ minWidth: "125px" }}>
                  Liquid Class
                </TableCell>
                <TableCell style={{ minWidth: "125px" }}>
                  Liquid Class
                </TableCell>
              </TableHead>
              {plateWorklistInfo.plates.map(
                (plate: any, plateIndex: number) => (
                  <IncludedFeedPlate
                    runIndex={runIndex}
                    plateIndex={plateIndex}
                    plateWorklistInfo={plateWorklistInfo.plates[plateIndex]}
                    updatePlateWorklistInfo={updatePlateWorklistInfo}
                    updateIncludedPlateSelection={updateIncludedPlateSelection}
                    setPlateMapOpen={setPlateMapOpen}
                    setSelectedPlate={setSelectedPlate}
                  ></IncludedFeedPlate>
                )
              )}
            </Table>
          </Collapse>
        </div>
      ) : null}
    </>
  );
};
